export default __webpack_public_path__ + "static/media/candidateUploadImg.abad5e8e.jpg";